import React from 'react';

import { Box } from '@mantine/core';

import { ProjectHelpers } from 'helpers/ProjectHelpers';

import { useSnapshot } from 'hooks/use-safe-snapshot';
import { loadingState } from 'state/loading';

import { DiagramGridBackground } from '../diagram/components/diagram-grid/DiagramGridBackground';

import cx from './LoadingOverlay.module.scss';

const LoadingOverlay = () => {
    const { page, suspense, destination } = useSnapshot(loadingState);

    return (
        <>
            <Box className={cx.bar} data-loading={page || suspense} />
            {page && ProjectHelpers.isEditorPath(destination) && (
                <Box className={cx.overlay}>
                    <DiagramGridBackground loading />
                </Box>
            )}
        </>
    );
};

export { LoadingOverlay };
